const products = [
  {
    name: 'Строп петлевой текстильный',
    capacity: '3т',
    width: '50мм',
    length: '4м',
    price: '3469₸',
    image:
      'https://tssp.kz/_ipx/f_webp&s_800x800/https://storage.tssp.kz/uploads/7875/images/RUfzD04i.jpg',
    features: ['Полиэстер', '7:1 запас прочности', 'Цветная маркировка'],
  },
  {
    name: 'Строп петлевой текстильный',
    capacity: '1т',
    width: '30мм',
    length: '1м',
    price: '799₸',
    image:
      'https://tssp.kz/_ipx/f_webp&s_800x800/https://storage.tssp.kz/uploads/images/product-images/bZgk0JswrTOjFVyUOg3Q-217a08a2-969c-4a63-bdf7-6e07663be882.jpg',
    features: ['Полиэстер', '7:1 запас прочности', 'Цветная маркировка'],
  },
  {
    name: 'Строп петлевой текстильный',
    capacity: '3т',
    width: '75мм',
    length: '4м',
    price: '3300₸',
    image:
      'https://tssp.kz/_ipx/f_webp&s_800x800/https://storage.tssp.kz/uploads/images/product-images/Bw1Jq5TaddNqM7So4eR3-c2254b65-38e9-4022-b803-876aad0f0ac7.jpg',
    features: ['Полиэстер', '7:1 запас прочности', 'Цветная маркировка'],
  },
];

export default products;
